import React from "react";
import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import { Dispatcher } from "../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import { alertsFilterMultiSelectSx } from "./AlertsUtils/alertsFilterBar";

export const CameraDropDownAlertsPage = ({
  setUserFilters,
  cameraOptions,
  cameraDropDownValue,
  setCameraDropDownValue,
  siteOptions,
  loadingCameras,
}: {
  setUserFilters: Dispatcher<any>;
  cameraOptions: any;
  cameraDropDownValue: string[];
  setCameraDropDownValue: Dispatcher<string[]>;
  siteOptions: any;
  loadingCameras: boolean;
  navBarCollapsed: boolean;
}) => {
  const cameraNamesMap = new Map();
  cameraOptions.forEach((object: any) => {
    cameraNamesMap.set(object.id, object.camera_name);
  });

  const siteIdsMap = new Map();
  siteOptions.forEach((object: any) => {
    siteIdsMap.set(object.name, object.id);
  });

  // Convert cameraDropDownValue strings to objects for the Autocomplete.
  // Memoized so the array keeps its identity across unrelated re-renders:
  // MUI treats a new `value` reference as a selection change and clears
  // the typed search text (SUP-868).
  const selectedCameraObjects = React.useMemo(
    () =>
      cameraDropDownValue.map((cameraName: string) => ({
        id: cameraOptions.find(
          (object: any) => object.camera_name === cameraName
        )?.id,
        name: cameraName,
      })),
    [cameraDropDownValue, cameraOptions]
  );

  return (
    <div className="w-full">
      <Autocomplete
        disablePortal
        multiple
        size="small"
        sx={alertsFilterMultiSelectSx}
        limitTags={1}
        value={selectedCameraObjects}
        options={
          cameraOptions[0]
            ? cameraOptions.map((object: any, index: number) => ({
              id: object.id,
              name: object.camera_name,
              index: index,
            }))
            : []
        }
        getOptionLabel={(option) => option.name || ""}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        loading={loadingCameras}
        onChange={(event, value: any[]) => {
          if (value && value.length > 0) {
            const cameraIdsArray: string[] = [];
            const cameraValuesArray: string[] = [];
            value.forEach((cameraObject: any) => {
              cameraIdsArray.push(cameraObject.id);
              cameraValuesArray.push(cameraObject.name);
            });
            setCameraDropDownValue(cameraValuesArray);
            setUserFilters((previousState: any) => {
              return { ...previousState, camera: cameraIdsArray };
            });
          } else {
            setCameraDropDownValue([]);
            setUserFilters((previousState: any) => {
              return {
                ...previousState,
                camera: [],
              };
            });
          }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            size="small"
            label="Camera"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loadingCameras ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
            autoComplete="off"
          />
        )}
        renderOption={(props, option) => (
          <li {...props} key={option.id}>
            {option.name}
          </li>
        )}
      />
    </div>
  );
};
